import { createActions, createReducer } from 'reduxsauce'

import ConsultaAdvertenciaFornecedorService from '../../servicos/ConsultaAdvertenciaFornecedorService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaAdvertenciaFornecedorInicio: [],
    buscaConsultaAdvertenciaFornecedorErro: ['erro'],
    buscaConsultaAdvertenciaFornecedorSucesso: ['consultaAdvertenciaFornecedor'],
    limpar: [],
    setConsultaAdvertenciaFornecedorEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaAdvertenciaFornecedor = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaAdvertenciaFornecedorInicio())
        let serv = new ConsultaAdvertenciaFornecedorService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaAdvertenciaFornecedorSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaAdvertenciaFornecedorErro(error)))
    }
}

// Ação para busca completa
Creators.buscaSancoesAplicadasContratados = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaAdvertenciaFornecedorInicio())
        let serv = new ConsultaAdvertenciaFornecedorService()
        return serv
            .consultarSancoes(filtro)
            .then(response => dispatch(Creators.buscaConsultaAdvertenciaFornecedorSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaAdvertenciaFornecedorErro(error)))
    }
}

const buscaConsultaAdvertenciaFornecedorInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaAdvertenciaFornecedorErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaAdvertenciaFornecedorSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaAdvertenciaFornecedor.resultado,
        dataSincronizacaoDados: action.consultaAdvertenciaFornecedor.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaAdvertenciaFornecedorEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_ADVERTENCIA_FORNECEDOR_INICIO]: buscaConsultaAdvertenciaFornecedorInicio,
    [Types.BUSCA_CONSULTA_ADVERTENCIA_FORNECEDOR_ERRO]: buscaConsultaAdvertenciaFornecedorErro,
    [Types.BUSCA_CONSULTA_ADVERTENCIA_FORNECEDOR_SUCESSO]: buscaConsultaAdvertenciaFornecedorSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_ADVERTENCIA_FORNECEDOR_ESTADO_DT]: setConsultaAdvertenciaFornecedorEstadoDT,
})
